import storageService from '../services/platform/storageService';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Build a WebSocket URL for a given path using the configured backend URL.
 * Falls back to the current window host if REACT_APP_BACKEND_URL is not set
 * or cannot be parsed.
 */
export const getWebSocketUrl = (path) => {
  const targetPath = path.startsWith('/') ? path : `/${path}`;

  try {
    const backend = new URL(BACKEND_URL);
    backend.protocol = backend.protocol === 'https:' ? 'wss:' : 'ws:';
    backend.pathname = targetPath;
    backend.search = '';
    backend.hash = '';
    return backend.toString();
  } catch (error) {
    console.error('Falling back to window host for WebSocket:', error);
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//${window.location.host}${targetPath}`;
  }
};

export const getUserWebSocketUrl = (userId) => {
  const base = getWebSocketUrl(`/ws/${userId}`);
  // Attach JWT so the server can authenticate the connection.
  // storageService.getItemSync mirrors to localStorage on both web and native.
  const token = storageService.getItemSync('edsupp_token');
  return token ? `${base}?token=${encodeURIComponent(token)}` : base;
};

export const parseWebSocketMessage = (eventData) => {
  const parsed = typeof eventData === 'string' ? JSON.parse(eventData) : eventData;
  const notification =
    parsed?.data?.notification ||
    parsed?.notification ||
    parsed?.data ||
    parsed;

  const notificationType =
    notification?.type ||
    notification?.notification_type ||
    notification?.data?.type ||
    notification?.data?.notification_type;

  const childId =
    notification?.child_id ||
    notification?.student_id ||
    notification?.data?.child_id ||
    notification?.data?.childId ||
    notification?.data?.student_id;
  const taskId =
    notification?.task_id ||
    notification?.data?.task_id ||
    notification?.data?.taskId;

  return {
    notification,
    notificationType,
    childId,
    taskId
  };
};